// extracted by mini-css-extract-plugin
module.exports = {"container":"_3YJAGVb- mx-auto col-12 md-col-4 mt1","label":"_1gbyJEb3","graphic":"_1SRadvGu"};